import { c as _c } from "react/compiler-runtime";
import React from 'react';
const AffiliateStatisticSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-1/3 justify-center"><div className="bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent ">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-1/3 justify-center"><div className="bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent ">.</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-background-secondary flex rounded-b-lg px-6 py-4">{t0}{t1}<div className="flex w-1/3 justify-center"><div className="bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent ">.</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default AffiliateStatisticSkeleton;